import { Box } from '@mui/material';
import type { FC, ReactNode } from 'react';
import {
  FLOATING_TABBAR_BAR_GAP,
  FLOATING_TABBAR_BOTTOM_INSET,
  FLOATING_TABBAR_HORIZONTAL_INSET,
} from '../../helpers/floatingTabbarLayout';
import { FloatingTabStrip } from './FloatingTabStrip';
import type { FloatingTab } from './types';
import { useFloatingTabStrip } from './useFloatingTabStrip';

type FloatingTabbarProps = {
  tabs: FloatingTab[];
  selectedId: string;
  onSelect: (id: string) => void;
  action?: ReactNode;
};

export const FloatingTabbar: FC<FloatingTabbarProps> = ({ tabs, selectedId, onSelect, action }) => {
  const strip = useFloatingTabStrip({ tabs, selectedId, onSelect });

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'stretch',
        gap: `${FLOATING_TABBAR_BAR_GAP}px`,
        px: `${FLOATING_TABBAR_HORIZONTAL_INSET}px`,
        pb: `calc(${FLOATING_TABBAR_BOTTOM_INSET}px + var(--tg-viewport-content-safe-area-inset-bottom, 0px) + var(--tg-viewport-safe-area-inset-bottom, 0px))`,
        boxSizing: 'border-box',
        pointerEvents: 'none',
        position: 'relative',
        zIndex: 1400,
      }}
    >
      <FloatingTabStrip tabs={tabs} selectedId={selectedId} strip={strip} />
      {action}
    </Box>
  );
};
